import { createContext } from "react";

/**
 * Whether `PrimaryControlsStripTitle`s in this subtree may publish. A screen that mounts several surfaces at
 * once — the Learn deck keeps the current card's hidden face and the prepared next card mounted —
 * sets this `false` around the surfaces that are not the learner's live one, so a background
 * surface's title never replaces the header. Defaults to `true`; route focus still applies.
 */
export const PrimaryControlsStripTitlePublishingContext = createContext(true);
